import { Box, Grid, Link, Typography, Paper, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const RecommendedBrowserPage = () => {
  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid container direction={'row'} justifyContent={'center'} spacing={2}>
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Paper
              style={{
                padding: '20px',
                marginTop: '20px',
                marginBottom: '20px',
                border: '1px solid lightgray',
                borderRadius: '4px',
                maxWidth: '90%',
                width: '100%'
              }}
            >
              <Typography className="text-primary text-center font-bold" fontSize={18} mb={2}>
                推奨環境
              </Typography>
              <div className="p-6 max-w-3xl mx-auto">
                {/* PC */}
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className="font-semibold">PCをお使いの方</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="space-y-4">
                      <div>
                        <Typography className="font-medium">Windows</Typography>
                        <ul className="list-disc list-inside pl-4">
                          <li>Chrome 最新版</li>
                          <li>Microsoft Edge 最新版</li>
                        </ul>
                      </div>
                      <div>
                        <Typography className="font-medium">Mac</Typography>
                        <ul className="list-disc list-inside pl-4">
                          <li>Chrome 最新版</li>
                          <li>Safari 最新版</li>
                        </ul>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>

                {/* SP */}
                <Accordion defaultExpanded>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography className="font-semibold">スマートフォンをお使いの方</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="space-y-4">
                      <div>
                        <Typography className="font-medium">Android</Typography>
                        <ul className="list-disc list-inside pl-4">
                          <li>Chrome 最新版</li>
                        </ul>
                      </div>
                      <div>
                        <Typography className="font-medium">iOS</Typography>
                        <ul className="list-disc list-inside pl-4">
                          <li>Safari 最新版</li>
                        </ul>
                      </div>
                      <div>
                        <Typography className="font-medium">LINE</Typography>
                        <ul className="list-disc list-inside pl-4">
                          <li>LINEアプリ 最新版</li>
                          <Typography fontSize={14}>
                            ＊詳細は
                            <Link
                              href="https://developers.line.biz/ja/docs/liff/overview/#when-the-liff-app-is-opened-in-a-liff-browser"
                              target="_blank"
                              rel="noopener"
                            >
                              LINE公式ページ
                            </Link>
                            を参照ください
                          </Typography>
                        </ul>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </Paper>
          </Box>
        </Grid>
      </Box>
    </>
  );
};
